import auditTrailFiltersSignal, {
	setAuditTrailFilters,
} from '@UI/Pages/Administration/AuditTrail/Filters/Signals/auditTrailFiltersSignal';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import useDebounce from '@UI/Hooks/useDebounce';
import { InputNumber } from '@verclam/ui-kit';

const DEBOUNCE_DELAY_IN_MILLISECONDS = 300;

type Props = {
	readonly withLabel?: boolean;
};

/**
 * Keeps local state for immediate keystroke feedback while the write to the signal is debounced; blur
 * writes immediately. The local state is resynchronised from the signal whenever it changes for another
 * reason (typically a filter reset), so the field never shows a stale value.
 */
const ResourceIdFilter: React.FC<Props> = ({ withLabel = false }) => {
	const currentFilters = useSignalValue(auditTrailFiltersSignal);
	const [input, setInput] = React.useState<number | null>(currentFilters.resourceId);
	const debouncedInput = useDebounce(input, DEBOUNCE_DELAY_IN_MILLISECONDS);

	React.useEffect(() => {
		setInput(currentFilters.resourceId);
	}, [currentFilters.resourceId]);

	React.useEffect(() => {
		if (debouncedInput === auditTrailFiltersSignal.peek().resourceId) {
			return;
		}

		setAuditTrailFilters(auditTrailFiltersSignal.peek().setResourceId(debouncedInput));
	}, [debouncedInput]);

	const handleBlur = React.useCallback(() => {
		if (input !== auditTrailFiltersSignal.peek().resourceId) {
			setAuditTrailFilters(auditTrailFiltersSignal.peek().setResourceId(input));
		}
	}, [input]);

	return (
		<InputNumber
			name="auditTrailResourceId"
			label="Identifiant de ressource"
			isLabelHidden={!withLabel}
			placeholder="Identifiant de ressource"
			useGrouping={false}
			min={1}
			value={input}
			onChange={setInput}
			onBlur={handleBlur}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default ResourceIdFilter;
